import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { SuggestSuppliersQueryResponse, SuggestSuppliersQueryParams } from "../../types/SuggestSuppliers";

/**
     * @summary Нечеткий поиск поставщиков по ИНН и названию
     * @link /api/private/v1/organization_suggest-suppliers
     */
export async function suggestSuppliers (params?: SuggestSuppliersQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<SuggestSuppliersQueryResponse>["data"]> {
    const { data: resData } = await client<SuggestSuppliersQueryResponse>({
        method: "get",
        url: `/api/private/v1/organization_suggest-suppliers`,
        params,
        ...options
    });
    
    return resData;
};